import script from "./CustomTableMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTableMenu.vue?vue&type=script&setup=true&lang=js"

import "./CustomTableMenu.vue?vue&type=style&index=0&id=fd7cc5cc&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd7cc5cc"]])

export default __exports__